const BookingStatus = {
    CONFIRMED: 'CONFIRMED',
    DRIVER_ASSIGNED: 'DRIVER-ASSIGNED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
};

export default BookingStatus;
